module.exports = __webpack_public_path__ + "static/media/VWFS_Logo_EN.a5c5f447.png";